
<template>
  <div id="Negligence">
    <b-button class="mt-4" variant="dark" v-on:click="changeMap">
      <b>Cases map in Hong Kong</b>
    </b-button>
    <b-button class="mt-4 mx-4" variant="dark" v-on:click="changeTable">
      <b>Cases category table</b>
    </b-button>
    <b-button class="mt-4" variant="dark" v-on:click="changeChart">
      <b>Waiting time for hearing</b>
    </b-button>
    <div class="container">
      <Tableau :url="url" :height="1000" :width="width" ref="tableau"></Tableau>
    </div>
  </div>
</template>

<script>
export default {
  name: "NegligenceMap",
  components: {},
  data() {
    return {
      url:
        "https://public.tableau.com/views/HK_medical_negligence_map_dashboard/Casemapdashboard",
      map_url:
        "https://public.tableau.com/views/HK_medical_negligence_map_dashboard/Casemapdashboard",
      table_url:
        "https://public.tableau.com/views/HK_medical_negligence_incident_dashboard/Incidentdashboard",
      chart_url:
        "https://public.tableau.com/views/HK_medical_negligence_chart_dashboard/Waitingtimedashboard",
      height: "500",
      width: "100%"
    };
  },
  methods: {
    changeMap: function(event) {
      if (event) {
        this.url = this.map_url;
      }
    },
    changeTable: function(event) {
      if (event) {
        this.url = this.table_url;
      }
    },
    changeChart: function(event) {
      if (event) {
        this.url = this.chart_url;
      }
    }
  },
  mounted() {
    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
  }
};
</script>


<style scoped>
.container {
  padding: auto;
  padding-top: 30px;
  padding-bottom: 30px;
  /* background-color: pink; */
}

.btn {
  font-size: 0.9rem !important;
}
</style>